<template>
  <v-container fluid>
    <v-dialog v-model="dialogCreateUser" persistent max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="ml-0 my-0 py-5 text-body-2 text-caption white--text elevation-2"
          v-bind="attrs"
          v-on="on"
          color="indigo"
        >
          Create a new user
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Create a new User</span>
        </v-card-title>
        <v-card-text>
          <v-container>
          <v-alert
            v-if="errorMessage"
            dense
            type="error"
          >
            {{(errorMessage == 'user exist') ? 'User with this email is exist' : errorMessage}}
          </v-alert>
            <v-row>
              <v-col cols="12" class="pb-0 pt-1">
                <v-text-field
                  type="text"
                  outlined 
                  dense   
                  v-model="newUser.firstName"
                  label="First Name"
                  class="my-0 pa-0"
                  maxlength="50"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span>First Name
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" class="pb-0 pt-1">
                <v-text-field
                  type="text"
                  outlined 
                  dense   
                  v-model="newUser.lastName"
                  label="Last Name"
                  class="my-0 pa-0"
                  maxlength="50"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" class="pb-0 pt-1">
                <v-text-field
                  type="text"
                  outlined 
                  dense   
                  v-model="newUser.email"
                  label="Email"
                  class="my-0 pa-0"
                  :rules="[rules.email]"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span>Email
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" class="pb-0 pt-1">
                <v-text-field
                  outlined 
                  dense   
                  v-model="newUser.password"
                  label="Password"
                  class="my-0 pa-0"
                  :rules="[rules.passwordRules]"
                  :append-icon="!showNewUserPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showNewUserPassword = !showNewUserPassword"
                  :type="showNewUserPassword ? 'password' : 'text'"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span>Password
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" class="pb-0 pt-1">    
                <v-select
                  dense
                  :items="listRoles"
                  v-model="newUser.role"
                  :menu-props="{ maxHeight: '400' }"
                  label="User role"
                  outlined
                  class="pa-0"
                  tags
                  show-select
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span>User role
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" v-if="newUser.role == 'Admin'" class="pb-0 pt-1">   
                <v-select
                  disabled
                  dense
                  :items="listCompanies"
                  item-text="name"
                  item-value="id"
                  v-model="listCompanies"
                  :menu-props="{ maxHeight: '400' }"
                  label="Available companies"
                  multiple
                  outlined
                  class="chip"
                  chips
                  show-select
                ></v-select>
              </v-col>
              <v-col cols="12" v-if="newUser.role !== 'Admin'" class="pb-0 pt-1">   
                <v-select
                  dense
                  :items="listCompanies"
                  item-text="name"
                  item-value="id"
                  v-model="newUser.availableCompanies"
                  :menu-props="{ maxHeight: '400' }"
                  label="Available companies"
                  multiple
                  outlined
                  class="chip"
                  chips
                  show-select
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span>Available companies
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" v-if="newUser.role == 'User'" class="pb-0 pt-1">
                <div class="text-h6 black--text mb-4">User rights</div>
                <v-checkbox
                  v-for="(right, i) in userRights"
                  :key="i"
                  v-model="newUser.rights[i]"
                  :label="right.text"
                  hide-details
                  color="indigo"
                  :value="right.value"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" class="pb-0 pt-1">
                  <v-switch v-model="newUser.sendNotificationAboutPosition">
                    <template v-slot:label>
                      <div class="ml-1">Send Notification About Position\Mode</div>
                    </template>
                  </v-switch>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="cancelCreateUser">Cancel</v-btn>
          <v-btn color="blue darken-1" text :disabled="validationNewUser" @click="createUser">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card class="elevation-2 py-0 px-2 mt-4 rounded-lg">
      <v-row class="px-4 pb-0 pt-3">
        <v-col cols="10" sm="7" md="5" class="pb-0">
          <v-text-field
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            outlined
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-col>
        <v-btn 
          color="#3F51B5" 
          class="mt-3" 
          dark 
          depressed 
          height='40'
          max-width='40'
          min-width='40'
          @click="cleanFilters"
        >
          <v-icon>
              mdi-autorenew
          </v-icon>
        </v-btn>
      </v-row>
      <v-row class="px-7 pb-0 pt-6">
        <v-col cols="12" sm="4" class="pa-0 mr-5">
          <v-select    
            dense
            v-model="filters.role"
            :items="roleFilter"
            :menu-props="{ maxHeight: '400' }"
            label="User role"
            multiple
            outlined
          ></v-select>
        </v-col>
        <v-col cols="12" sm="4" class="pa-0 mr-auto">
          <v-select   
            dense
            v-model="filters.availableCompanies"
            :items="companiesFilter"
            :menu-props="{ maxHeight: '400' }"
            label="Available company"
            multiple
            outlined
          ></v-select>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </v-card>
    <v-card class="elevation-2 py-1 px-0 mt-4 rounded-lg">
        <v-data-table
          :headers="headers"
          :items="dataFiltered"
          item-key="id"
          :search="search"
          :loading="loaded"
          loading-text="Loading... Please wait"
          id="datatable"
        >
          <template v-slot:item.actions="{ item }">
            <div class="d-flex flex-column">
              <v-icon
                small           
                @click="editUser(item)"
              >
                mdi-pencil
              </v-icon>
              <v-icon
                small           
                @click="removeUser(item)"
                v-if="item.email != himself"
              >
                mdi-trash-can-outline
              </v-icon>
            </div>
          </template>
          <template v-slot:item.availableCompanies="{ item }">
            <span>{{ item.availableCompanies.map(i => i.name).join(", ") }}</span>
          </template>
        </v-data-table>
         <v-dialog v-model="dialogEditUser" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Edit User</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-alert
                v-if="errorMessage"
                dense
                type="error"
              >
                {{(errorMessage == 'user exist') ? 'User with this email is exist' : errorMessage}}
              </v-alert>
              <v-row>
                <v-col cols="12" class="pb-0 pt-1">
                  <v-text-field
                    type="text"
                    outlined 
                    dense   
                    v-model="userEditForm.firstName"
                    label="First Name"
                    class="my-0 pa-0"
                    maxlength="50"
                  >
                    <template #label>
                      <span class="red--text"><strong>* </strong></span>First Name
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="pb-0 pt-1">
                  <v-text-field
                    type="text"
                    outlined 
                    dense   
                    v-model="userEditForm.lastName"
                    label="Last Name"
                    class="my-0 pa-0"
                    maxlength="50"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="pb-0 pt-1">
                  <v-text-field
                    type="text"
                    outlined 
                    dense   
                    v-model="userEditForm.email"
                    label="Email"
                    class="my-0 pa-0"
                    :rules="[rules.email]"
                    readonly
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="pb-0 pt-1">
                  <v-text-field
                    outlined 
                    dense   
                    v-model="userEditForm.password"
                    label="Password"
                    class="my-0 pa-0"
                    :rules="[rules.passwordRules]"
                    :append-icon="!showEditUserPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showEditUserPassword = !showEditUserPassword"
                    :type="showEditUserPassword ? 'password' : 'text'"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="pb-0 pt-1">    
                  <v-select
                    dense
                    :items="listRoles"
                    v-model="userEditForm.role"
                    :menu-props="{ maxHeight: '400' }"
                    label="User role"
                    outlined
                    class="pa-0"
                    tags
                    show-select
                  >
                    <template #label>
                      <span class="red--text"><strong>* </strong></span>User role
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" v-if="userEditForm.role !== 'Admin' && userEditForm.role" class="pb-0 pt-1">    
                  <v-select
                    dense
                    :items="listCompanies"
                    item-text="name"
                    item-value="id"
                    v-model="userEditForm.availableCompanies"
                    :menu-props="{ maxHeight: '400' }"
                    label="Available companies"
                    multiple
                    outlined
                    chips
                    class="chip"
                    show-select
                  >
                    <template #label>
                      <span class="red--text"><strong>* </strong></span>Available companies
                    </template>                 
                  </v-select>
                </v-col>
                <v-col cols="12" v-if="userEditForm.role == 'Admin'" class="pb-0 pt-1">    
                  <v-select
                    disabled
                    dense
                    :items="listCompanies"
                    item-text="name"
                    item-value="id"
                    v-model="listCompanies"
                    :menu-props="{ maxHeight: '400' }"
                    label="Available companies"
                    multiple
                    outlined
                    chips
                    class="chip"
                    show-select
                  ></v-select>
                </v-col>
                <v-col cols="12" v-if="userEditForm.role && userEditForm.role == 'User'" class="pb-0 pt-1">
                  <div class="text-h6 black--text mb-4">User rights</div>
                  <div class="d-flex flex-column">
                    <div
                      v-for="(right, i) in userRights"
                      :key="i"
                      class="d-flex"
                    >
                      <v-checkbox
                        v-model="userEditForm.rights"
                        hide-details
                        color="indigo"
                        :value="right.value"
                        class="mt-0 mr-2"
                      ></v-checkbox>
                      <p class="text-body-1">{{right.text}}</p>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" class="pb-0 pt-1">
                  <v-switch v-model="userEditForm.sendNotificationAboutPosition">
                    <template v-slot:label>
                      <div class="ml-3">Send Notification About Position\Mode</div>
                    </template>
                  </v-switch>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="cancelEditUser">Cancel</v-btn>
            <v-btn color="blue darken-1" text :disabled="validationEditUser" @click="saveEditUser">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogRemoveUser" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Remove User</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                Are you sure you want to remove {{userEditForm.userName}}
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="cancelRemoveUser">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="confirmRemoveUser">Confirm</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>

<script>
import axios from '@/api/axios-auth'

export default {
  name: 'user-management',
  data() {
    return {
      himself: localStorage.username,
      users: [],
      headers: [
        {text: 'Actions', value: 'actions', class: 'black--text', sortable: false},
        {text: 'User Name', value: 'userName', class: 'black--text'},
        {text: 'Role', value: 'role', class: 'black--text'},
        {text: 'Available companies', value: 'availableCompanies', class: 'black--text'},
        {text: 'Last edit date', value: 'lastEditDate', class: 'black--text'},
      ],
      search: '',
      defaultPage: [],
      numberOwners: [],
      filters: {
        'role': [],
        'availableCompanies': [],
      },
      dialogCreateUser: false,
      userEditForm: {},
      dialogEditUser: false,
      dialogRemoveUser: false,
      loaded: false,
      listCompanies: [],
      listRoles: ['Admin', 'User'],
      newUser: {
        rights: [],
        email: null,
        password: null,
        firstName: null,
        lastName: null,
        availableCompanies: [],
        role: null,
        sendNotificationAboutPosition: false
      },
      userRights: [
        {text: 'Cruise Campaign Management', value: 'cruiseCampaignManagement'},
        {text: 'Settings.Keyword Mapping', value: 'keywordMapping'},
        {text: 'Settings.Rank', value: 'rank'},
        {text: 'Sales Report.Keyword Adding', value: 'salesReportAddKeyword'},
      ],
      rules: {
        required: value => !!value || 'Required.',
        counter: value => value.length <= 50 || 'Max 50 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
        passwordRules: v => (v && v.length > 8) || 'Password must be more than 8 characters',
      },
      errorMessage: null,
      showNewUserPassword: true,
      showEditUserPassword: true,
    }
  },
  mounted(){
    this.getUsers()
    this.getCompanies()  
  },
  computed: {
    validationNewUser(){
      return !this.newUser.firstName ||
             !this.newUser.email ||
             !this.newUser.password ||
             (this.newUser.password && this.newUser.password.length < 9) ||
             !this.newUser.role ||
             (this.newUser.role !== "Admin" && this.newUser.availableCompanies.length === 0)
    },
    validationEditUser(){
      return !this.userEditForm.firstName ||
             !this.userEditForm.email ||
             (this.userEditForm.password && this.userEditForm.password.length < 9) ||
             !this.userEditForm.role ||
             (this.userEditForm.role !== "Admin" && this.userEditForm.availableCompanies.length === 0)
    },
    roleFilter(){
      let data = this.users.map(e => e.role).filter((x, i, a) => a.indexOf(x) == i)
                .sort((a, b) => a.localeCompare(b))
      return this._.compact(data)
    },
    companiesFilter(){
      let data = this.listCompanies.map(e => e.name).filter((x, i, a) => a.indexOf(x) == i)
          .sort((a, b) => a.localeCompare(b))
      return this._.compact(data)
    },
    dataFiltered(){
      return this.users.filter(d => {
        return Object.keys(this.filters).every(f => {
          return typeof d[f] !== 'string' ? (this.filters[f].length < 1 || d[f].some(e => this.filters[f].includes(e.name))) : (this.filters[f].length < 1 || this.filters[f].includes(d[f]))
        })
      })
    },
  },
  methods: {
    getUsers(){
      this.loaded = true
      axios
      .get('/users')
      .then(response => {
        this.users = response.data.data
        this.users.map(e => e.userName = `${e.firstName} ${(e.lastName) ? e.lastName : ''}`)

        this.loaded = false
      })
    },
    getCompanies(){
      axios
      .get('/companies')
      .then(response => {
        this.listCompanies = response.data.data
      })
    },
    cleanFilters(){
      this.search = ''

      this.filters.role = []
      this.filters.availableCompanies = []
    },
    editUser(item){
      this.userEditForm = JSON.parse(JSON.stringify(item))

      this.dialogEditUser = true
    },
    cancelEditUser(){
      this.dialogEditUser = false
      this.userEditForm = {}
      this.showEditUserPassword = true
      this.errorMessage = null
    },
    saveEditUser(){
      if (typeof this.userEditForm.availableCompanies[0] == "number") {
        this.userEditForm.availableCompanies = this.userEditForm.availableCompanies.map(e => {
          return {id: e}
        })
      } else {
        this.userEditForm.availableCompanies = (this.userEditForm.role == "Admin") 
                    ? this.listCompanies.map(e => ({id: e.id}))
                    : this.userEditForm.availableCompanies.map(e => ({id: e.id}))
      }

      this.userEditForm.rights = (this.userEditForm.role == "Admin") 
                    ? this.userRights.map(e => e.value)
                    : this.userEditForm.rights

      axios({
        url: '/users',
        method: 'put',
        data: this.userEditForm
      }).then(response => {
          console.log('Response Edit User', response.data)
          this.userEditForm = {}
          this.errorMessage = null
          this.showEditUserPassword = true
          this.getUsers()
          this.dialogEditUser = false
        }).catch(error => {
          this.errorMessage = error.response.data
        })

    },
    removeUser(item){
      this.userEditForm = JSON.parse(JSON.stringify(item))
      this.dialogRemoveUser = true
    },
    confirmRemoveUser(){
      axios
        .delete('/users/' + this.userEditForm.id)
        .then(() => {
          this.userEditForm = {}
          this.getUsers()
          this.dialogRemoveUser = false
        })
    },
    cancelRemoveUser(){
      this.userEditForm = {}
      this.dialogRemoveUser = false
    },
    cancelCreateUser(){
      this.newUser = {
        rights: [],
        email: null,
        password: null,
        firstName: '',
        lastName: '',
        availableCompanies: [],
        role: null,
      }
      this.errorMessage = null
      this.showEditUserPassword = true
      this.dialogCreateUser = false
    },
    createUser(){
      this.newUser.rights = (this.newUser.role == "Admin") 
                          ? this.userRights.map(e => e.value)
                          : this.newUser.rights

      this.newUser.availableCompanies = (this.newUser.role == "Admin") 
                          ? this.listCompanies.map(e => ({id: e.id}))
                          : this.newUser.availableCompanies.map(e => ({id: e}))

      
      axios({
        url: '/users',
        method: 'post',
        data: this.newUser
      }).then(response => {
          console.log('Response Create User', response.data)
          this.dialogCreateUser = false
          this.errorMessage = null
          this.showNewUserPassword = true
          this.newUser = {
            rights: [],
            email: null,
            password: null,
            firstName: '',
            lastName: '',
            availableCompanies: [],
            role: null,
          }
          this.getUsers()
          this.getCompanies()
        }).catch(error => {
          this.errorMessage = error.response.data
          console.log(error.response.data)
        })    
    },
  }
}

</script>

<style scoped>
  .chip::v-deep .v-chip {
    border-radius: 16px;
    font-size: 13px;
    height: 20px !important;
    color: white;
    background-color: #BDBDBD;
    margin: 4px 4px 0px 4px;
}
</style>